<template>
    <div ref="loading">
		
	</div>
</template>
<script>
import { useAuthStore, useUtilsStore } from "@/store";
export default {
	data() {
		return {
			code : "",
			username: "",
			serviceId: this.$route.query.service_id, 
			redirectUrl: this.$route.query.redirect_url,
		}
	},
	async mounted(){
		let loader = this.$loading.show({
			container: this.$refs.loading,
			canCancel: false,
		});
		const authStore = useAuthStore();
		authStore.serviceId = this.serviceId;
		authStore.redirectUrl = this.redirectUrl;
		if(authStore.CUID){
			this.username = authStore.userInfoMyVTC.AccountName;
			await authStore.logout();
			loader.hide()
		}
		authStore.username = this.username;
		if(this.redirectUrl){
			useUtilsStore().redirectWithParams(`${authStore.redirectUrl}`)
		}		
	}
};
</script>
<style scoped>
@import url(~@/assets/css/form.css);
</style>